import React, { forwardRef, useEffect, useRef, useState } from "react";
import Typed from "react-typed";
import CountUp from "react-countup";
import { PopupButton } from "react-calendly";

const Home = forwardRef(function Home({ handleClick }, refHome) {
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

  
  return (
    <div
      className="page flex flex-col items-center justify-center min-h-screen text-center md:text-left md:flex-row md:justify-around px-6 md:px-20"
      ref={refHome}
    >
      <div className="flex flex-col mb-10 md:mb-0 space-y-2 md:space-y-4">
        <h2 className="md:text-6xl text-4xl font-extrabold tracking-tight text-white drop-shadow-md">Hi,</h2>
        <h2 className="md:text-5xl text-3xl font-extrabold text-gray-300 drop-shadow-md">
          My name is
        </h2>
        <h2 className="md:text-6xl sm:text-5xl text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#00df9a] to-emerald-400 drop-shadow-lg py-2">
          Martin Mircea
        </h2>
      </div>

      <div className="flex flex-col w-full md:w-1/2 items-center md:items-start bg-white/5 backdrop-blur-lg rounded-3xl p-8 shadow-2xl border border-white/10">
        <div className="flex items-center space-x-3 mb-6">
          <Typed
            className="md:text-4xl sm:text-3xl text-2xl font-bold text-[#00df9a]"
            strings={["Android", "Frontend", "Java", "Web"]}
            typeSpeed={100}
            backSpeed={120}
            loop
          />
          <p className="md:text-4xl sm:text-3xl text-2xl font-bold text-white">
            Developer
          </p>
        </div>
        
        <div className="flex items-center space-x-4 mb-10 bg-black/20 px-6 py-4 rounded-2xl border border-white/5">
          <CountUp
            start={0}
            end={47}
            duration={3}
            suffix="+"
            className="md:text-5xl sm:text-4xl text-4xl font-black text-[#00df9a]"
          />
          <p className="md:text-2xl sm:text-xl text-lg font-semibold text-gray-300 uppercase tracking-wider">
            Projects<br/>Completed
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 w-full justify-center md:justify-start">
          <button
            className="bg-gradient-to-r from-[#00df9a] to-emerald-500 hover:from-emerald-400 hover:to-[#00df9a] transition-all duration-300 w-[220px] rounded-xl font-bold px-6 py-4 text-black shadow-lg shadow-emerald-500/30 hover:shadow-emerald-500/50 hover:-translate-y-1"
            onClick={handleClick}
          >
            View Portfolio
          </button>

          <button className="bg-transparent border-2 border-[#00df9a] text-[#00df9a] hover:bg-[#00df9a] hover:text-black transition-all duration-300 w-[220px] rounded-xl font-bold px-6 py-4 shadow-lg hover:shadow-emerald-500/30 hover:-translate-y-1">
            <PopupButton
              url="https://calendly.com/mirceamartinioan"
              rootElement={document.getElementById("root")}
              className="w-full h-full font-bold"
              text="Schedule a Meeting"
            />
          </button>
        </div>
      </div>
    </div>
  );
});

export default Home;
